import { useContext, useMemo } from "react";
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { message } from 'antd';
import { IMAGE_TYPE, RESOURCE_TYPE } from '@utils/CONST'
import { workflowOfLoadTaskInfo, workflowOfReGenerate, workflowOfSendTask } from '@utils/workflowOfBuildTaskV2';
import { useNavigate } from 'react-router-dom';
import API from '@api/api'
import { AppContext } from '@utils/AppContext'

const PicModalRightButton = (props) => {
    const { item, fetchProjectDetail, projectImageType } = props
    const navigate = useNavigate()
    // AI扩图的部分历史任务会返回通用 AI 编辑类型，以项目类型为准隐藏功能串联。
    const currentImageType = projectImageType === IMAGE_TYPE.IMAGE_OUTPAINTING
        ? projectImageType
        : item?.imageType
    const { setGlobalTaskReadFlag } = useContext(AppContext)

    const rebuildClick = async (commidityOldDataRebuild) => {
        const succeededItem = item
        if (succeededItem) {
            try {
                const res = await workflowOfLoadTaskInfo(succeededItem.imageType, succeededItem.taskId, commidityOldDataRebuild)
                if (!res) return
                const { pathname, options } = res
                navigate(pathname, options)
            } catch (err) {
                message.warning(err.message)
            }
        } else {
            message.warning('生成中，请等待完成后再编辑')
        }
    }

    const handleClick = async (jumpTotype, targetType = "inputImage", extraState) => {
        let noWaterRes = await API.commonDownload({ taskId: item?.taskId })
        if (noWaterRes?.code != 0) throw new Error(noWaterRes?.message)
        const image = noWaterRes.data

        const aiEditModes = ['handRepair', 'magicErase', 'image_extraction', 'imageResize', 'imageFiner', 'filllight']
        if (aiEditModes.includes(targetType)) {
            if (targetType === 'image_extraction') {
                window.open(image ? `/home/${targetType}?url=${encodeURIComponent(image)}` : `/home/${targetType}`, '_blank')
            } else if (targetType === 'imageResize') {
                navigate(image ? `/home/aiEdit?menuKey=imageResize&url=${encodeURIComponent(image)}` : `/home/aiEdit?menuKey=imageResize`)
            } else {
                navigate("/home/aiEdit", { state: { menuKey: targetType, picUrl: image } })
            }
            return
        }

        const res = await workflowOfSendTask(jumpTotype, image, targetType, extraState)
        if (!res) return
        const { pathname, options } = res
        navigate(pathname, options)
    }

    const createAgain = async () => {
        try {
            const response = await workflowOfReGenerate(item?.imageType, item?.taskId)
            if (!response) return
            const { disabled, pathname, options } = response
            if (disabled) {
                message.warning('版本更新，请重新编辑后再重新生成')
                navigate(pathname, options)
            } else {
                message.success('生成中，请稍候！')
                setGlobalTaskReadFlag(prev => !prev)
                fetchProjectDetail?.()
            }
        } catch (err) {
            message.warning(err.message)
        }
    }

    const isAiEdit = useMemo(() => {
        if (!item) return false
        return currentImageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            currentImageType == IMAGE_TYPE.REMOVE_INPAINT ||
            currentImageType == IMAGE_TYPE.AI_BEAUTY ||
            currentImageType == IMAGE_TYPE.IMAGE_FINER ||
            currentImageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            currentImageType == IMAGE_TYPE.IMAGE_RESIZE ||
            currentImageType == IMAGE_TYPE.HAND_FIX
    }, [currentImageType, item])

    const isPersonScene = useMemo(() => {
        const commodityTypes = [
            IMAGE_TYPE.COMMODITY,
            IMAGE_TYPE.COMMODITYRECOLOR,
            IMAGE_TYPE.WATERMARK_REMOVE,
            IMAGE_TYPE.FLATLAY3D,
        ]
        if (commodityTypes.includes(currentImageType)) return false
        if (currentImageType === IMAGE_TYPE.CLOTH_RECOLOR && !item?.clothReColorIsPerson) return false
        return true
    }, [currentImageType, item])

    const shouldHide = !item ||
        isAiEdit ||
        currentImageType === IMAGE_TYPE.IMAGE_OUTPAINTING ||
        item?.orgData;
    if (shouldHide) return null;

    if (currentImageType == IMAGE_TYPE.SMART_DETAILA_PAGE) {
        const reGroupButtons = [
            { label: '重新编辑', icon: 'icon-rebuildOutlined', onClick: () => rebuildClick() }
        ]
        if (item?.status === 'succeeded') {
            reGroupButtons.push({
                label: '编辑图片',
                icon: 'icon-Material-EditOutlined',
                onClick: () => props.onOpenMaterialEdit?.(item),
            })
        }

        return (
            <div className={`${styles.PicModalRightButton} _beauty_scrollbar`}>
                <div className={styles.group}>
                    <div className={styles.groupTitle}>再次操作</div>
                    {reGroupButtons.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    const modifyImageGroup = []
    const generateVideoGroup = []
    const aiEditGroup = []
    const reOperateGroup = [
        { label: '重新编辑', icon: 'icon-rebuildOutlined', onClick: () => rebuildClick() }
    ]
    let creativeImageButton = null

    if (isPersonScene) {
        creativeImageButton = { label: 'AI创意生图', icon: 'icon-genimageOutlined', onClick: () => handleClick(IMAGE_TYPE.CREATIVE_IMAGE_GEN) }
    } else if (![IMAGE_TYPE.IMAGE_TO_VIDEO, IMAGE_TYPE.MODEL_VIDEO].includes(currentImageType)) {
        creativeImageButton = { label: 'AI创意生图', icon: 'icon-genimageOutlined', onClick: () => handleClick(IMAGE_TYPE.CREATIVE_IMAGE_GEN) }
    }

    const leftMenus = [
        { label: '换衣服', icon: 'icon-outfitSmallOutlined', type: IMAGE_TYPE.CLOTHES, resourceType: RESOURCE_TYPE.TRYON_MODEL },
        { label: '换模特', icon: 'icon-aiModelOutlined', type: IMAGE_TYPE.MODEL },
        { label: '换背景', icon: 'icon-aibgOutlined', type: IMAGE_TYPE.BACKGROUND, condition: currentImageType !== IMAGE_TYPE.MODEL },
        { label: '换鞋子', icon: 'icon-shoesOutlined', type: IMAGE_TYPE.SHOES, resourceType: RESOURCE_TYPE.TRYON_SHOES },
        { label: '换眼镜', icon: 'icon-glassesOutlined', type: IMAGE_TYPE.GLASSES_TRYON, resourceType: RESOURCE_TYPE.GLASSES_TRYON },
        { label: '换项链', icon: 'icon-necklaceOutlined', type: IMAGE_TYPE.NECKLACE_TRYON, resourceType: RESOURCE_TYPE.NECKLACE_TRYON, extraState: { silentSelect: true } },
        { label: '换姿势', icon: 'icon-poseFantasyOutlined', type: IMAGE_TYPE.POSE_TRYON },
        { label: '服饰换色', icon: 'icon-recolorOutlined', type: IMAGE_TYPE.CLOTH_RECOLOR },
        { label: '同版型试衣', icon: 'icon-sametryOutlined', type: IMAGE_TYPE.SIM_TRYON, resourceType: RESOURCE_TYPE.SIM_TRYON },
    ]

    if (isPersonScene) {
        leftMenus
            .filter(menu => menu.type !== currentImageType && (menu.condition === undefined || menu.condition))
            .forEach(menu => {
                modifyImageGroup.push({
                    label: menu.label,
                    icon: menu.icon,
                    onClick: () => handleClick(menu.type, menu.resourceType, menu.extraState),
                })
            })
    }

    const middleMenus = []
    if (currentImageType !== IMAGE_TYPE.WATERMARK_REMOVE) {
        middleMenus.push({ label: '去水印', icon: 'icon-removeWatermark', type: IMAGE_TYPE.WATERMARK_REMOVE })
    }

    if (isPersonScene) {
        middleMenus.push(
            { label: '换穿搭', icon: 'icon-outfitSmallOutlined', type: IMAGE_TYPE.FUSION_WEAR, resourceType: RESOURCE_TYPE.FUSIONWEAR_MODEL },
            { label: '去种草', icon: 'icon-sProductshowcaseOutlined', type: IMAGE_TYPE.GRASS_PLANT },
            { label: '图生视频', icon: 'icon-tryonVideoOutlined', type: IMAGE_TYPE.IMAGE_TO_VIDEO },
            { label: '动作模仿', icon: 'icon-tryonVideoOutlined', type: IMAGE_TYPE.MODEL_VIDEO },
        )
    }

    if (currentImageType !== IMAGE_TYPE.COMMODITYRECOLOR) {
        middleMenus.push({ label: '商品换色', icon: 'icon-recolorOutlined', type: IMAGE_TYPE.COMMODITYRECOLOR })
    }

    if ([IMAGE_TYPE.COMMODITYRECOLOR, IMAGE_TYPE.WATERMARK_REMOVE].includes(currentImageType)) {
        middleMenus.push({ label: '商品换背', icon: 'icon-commidityOutlined', type: IMAGE_TYPE.COMMODITY })
    }

    if ([IMAGE_TYPE.COMMODITY, IMAGE_TYPE.COMMODITYRECOLOR, IMAGE_TYPE.WATERMARK_REMOVE, IMAGE_TYPE.FLATLAY3D].includes(currentImageType)) {
        if (!middleMenus.find(menu => menu.type === IMAGE_TYPE.IMAGE_TO_VIDEO) && currentImageType !== IMAGE_TYPE.IMAGE_TO_VIDEO) {
            middleMenus.push({ label: '图生视频', icon: 'icon-tryonVideoOutlined', type: IMAGE_TYPE.IMAGE_TO_VIDEO })
        }
        if (!middleMenus.find(menu => menu.type === IMAGE_TYPE.CLOTH_RECOLOR) && currentImageType !== IMAGE_TYPE.CLOTH_RECOLOR) {
            middleMenus.push({ label: '服饰换色', icon: 'icon-recolorOutlined', type: IMAGE_TYPE.CLOTH_RECOLOR })
        }
    }

    middleMenus
        .filter(menu => menu.type !== currentImageType)
        .forEach(menu => {
            const targetGroup = [IMAGE_TYPE.IMAGE_TO_VIDEO, IMAGE_TYPE.MODEL_VIDEO].includes(menu.type) ? generateVideoGroup : modifyImageGroup
            targetGroup.push({
                label: menu.label,
                icon: menu.icon,
                onClick: () => handleClick(menu.type, menu.resourceType, menu.extraState),
            })
        })

    if (![IMAGE_TYPE.COMMODITY, IMAGE_TYPE.COMMODITYRECOLOR, IMAGE_TYPE.FLATLAY3D].includes(currentImageType)) {
        aiEditGroup.push({ label: '修手', icon: 'icon-handRepairOutlined', onClick: () => handleClick(IMAGE_TYPE.AIEDIT, 'handRepair') })
    }

    aiEditGroup.push(
        { label: '抠图', icon: 'icon-mattingOutlined', onClick: () => handleClick(IMAGE_TYPE.AIEDIT, 'image_extraction') },
        { label: '改尺寸', icon: 'icon-picResizeOutlined', onClick: () => handleClick(IMAGE_TYPE.AIEDIT, 'imageResize') },
        { label: 'AI超清', icon: 'icon-hasHDOutlined', onClick: () => handleClick(IMAGE_TYPE.AIEDIT, 'imageFiner') },
        { label: '去杂物', icon: 'icon-magicRemoveOutlined', onClick: () => handleClick(IMAGE_TYPE.AIEDIT, 'magicErase') },
        { label: '修光影', icon: 'icon-lightIconOutlined', onClick: () => handleClick(IMAGE_TYPE.AIEDIT, 'filllight') },
    )

    reOperateGroup.push({
        label: '再次生成',
        icon: 'icon-generateOutlined',
        onClick: () => {
            if (currentImageType === IMAGE_TYPE.COMMODITY && item?.version !== 'V3.8.20251127') {
                rebuildClick(true)
            } else {
                createAgain()
            }
        }
    })

    return (
        <div className={`${styles.PicModalRightButton} _beauty_scrollbar`}>
            {creativeImageButton && (
                <div className={styles.group}>
                    <div className={`${styles.btn} ${styles.creativeBtn}`} onClick={creativeImageButton.onClick}>
                        <span className={styles.creativeIcon}></span>
                        {creativeImageButton.label}
                    </div>
                </div>
            )}

            {modifyImageGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>修改图片</div>
                    {modifyImageGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {generateVideoGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>生成视频</div>
                    {generateVideoGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {aiEditGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>AI 编辑</div>
                    {aiEditGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {reOperateGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>再次操作</div>
                    {reOperateGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default PicModalRightButton
